<!-- 特惠活动 -->
<template>
    <div class="">
      <!-- 导航头部组件 -->
      <HeaderNav chooseNav="1"></HeaderNav>
      <div class="img_box">
        <div class="pc_img"><img alt="" :src="pcImg" style="max-width: 1880px;width: 100%;" /></div>
        <!-- <div class="wap_img"><img alt="" :src="wapImg" style="max-width: 1080px;width: 100%;" v-for="(item, index) in wapImg" :key="index" /></div> -->
      </div>
      <hr class="hr_1 mt0 mb30" />
      <!-- 脚步导航组件 -->
      <FooterNav></FooterNav>
    </div>
  </template>
  
  <script>
  import HeaderNav from '../../components/HeaderNav';
  import FooterNav from '../../components/FooterNav';
  import RightNav from '../../components/RightNav.vue';
  import { apiGetAdvert, apiGetList } from '../../api/activity.js';
  export default {
    name: 'Index',
    components: {
      HeaderNav: HeaderNav,
      FooterNav: FooterNav,
      RightNav: RightNav
    },
    data() {
      return {
        pcImg: '',
        wapImg: [],
        video: {
          url: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
          cover: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png',
          muted: false,
          loop: false,
          preload: 'auto',
          poster: '',
          volume: 1,
          autoplay: false
        }
      };
    },
    created() {
      if (this.$route.query.id == 1) {
        this.pcImg = 'static/picture/MAESOUL/pc1.jpg';
        // this.wapImg =['static/picture/FOLKTALE/detail/hl/sj (3).jpg', ''];
      }
      if (this.$route.query.id == 2) {
        this.pcImg = 'static/picture/MAESOUL/pc2.jpg';
        // this.wapImg = ['static/picture/FOLKTALE/detail/hl/cm (3).jpg', ''];
      }
      if (this.$route.query.id == 3) {
        this.pcImg = 'static/picture/MAESOUL/pc3.jpg';
        // this.wapImg = ['static/picture/FOLKTALE/detail/hl/dhmrj (3).jpg', ''];
      }
      
    },
    methods: {}
  };
  </script>
  <style scoped>
  /* @media screen and (min-width: 0px) and (max-width: 768px) { */
  @media (min-width: 768px){
    .nav li {
      padding: 0 15px;
    }
    .pc_img {
      display: none;
    }
    .wap_img {
      display: block;
    }
    .img_box .video_box .zhezhao img.img_pc {
      display: none;
    }
    .img_box .video_box .zhezhao img.img_wap {
      display: block;
    }
  }
  
  @media (min-width: 768px) {
    .pc_img {
      display: block;
    }
    .wap_img {
      display: none;
    }
    .img_box .video_box .zhezhao img.img_pc {
      display: block;
    }
    .img_box .video_box .zhezhao img.img_wap {
      display: none;
    }
  }
  /*------------brand.html  start----------------*/
  .img_box {
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
  }
  .img_box img {
    max-width: 100%;
    margin: 0 auto;
    display: block;
  }
  .img_box .video_box {
    width: 100%;
    margin: 0 auto;
    position: relative;
  }
  .img_box .video_box .zhezhao {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0px;
    top: 0px;
    z-index: 555;
    overflow: hidden;
    cursor: pointer;
  }
  .img_box .video_box .zhezhao img {
    width: 100%;
    height: 100%;
    transition: all 1s ease-in-out;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: none;
  }
  .img_box .video_box video {
    width: 100%;
  }
  /*------------brand.html  end----------------*/
  </style>
  


// WEBPACK FOOTER //
// src/view/Hoctime/Detail.vue